import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/plugins/i18n/locales/en'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: {
    en: messages,
  }, // set locale messages
  silentTranslationWarn: !process.env.LANG_WARNS,
})

const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang

  return lang
}

export function loadLanguageAsync(lang) {
  // validate if lang is a string
  if (!lang || typeof lang !== 'string') {
    return Promise.resolve(i18n.locale)
  }

  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  /* eslint-disable prefer-template */
  return import(/* webpackChunkName: "lang-[request]" */ '@/plugins/i18n/locales/' + lang + '.js').then(msgs => {
    const msg = msgs.default

    // Remove empty translations to allow fallback
    Object.keys(msg).forEach(key => {
      if (typeof msg[key] === 'object' && msg[key] !== null) {
        Object.keys(msg[key]).forEach(nestedKey => {
          if (msg[key][nestedKey] === '') {
            delete msg[key][nestedKey]
          }
        })
      } else if (msg[key] === '') {
        delete msg[key]
      }
    })

    i18n.setLocaleMessage(lang, msg)
    loadedLanguages.push(lang)

    return setI18nLanguage(lang)
  }).catch(error => {
    console.error(`Error loading language ${lang}:`, error)
    return Promise.resolve(i18n.locale)
  })
  /* eslint-enable */
}
